import React, { useEffect, useState } from "react";
import { Arrow, Button, Container, Dot } from "../../Styles/Global.Styled";
import { groupArrayByNumber } from "../../helpers/utilis";
import { css } from "styled-components";

const cntStyle = css`
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  gap: 3vh;
`;
const contentCntStyle = css`
  align-items: center;
  gap: 4vh;
`;
const gapStyle = css`
  gap: 1vh;
`;
const paddingStyle = css`
  padding: 1vh 0;
`;

const Carousel = ({ items = [], Component = "" }) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    const updateVisibleItems = () => {
      const screenWidth = window.innerWidth;
      let itemsPerSlide = 4;

      // Adjust itemsPerSlide for mobile view
      if (screenWidth <= 768) {
        itemsPerSlide = 1;
      }

      setVisibleItems(groupArrayByNumber(items, itemsPerSlide));
    };

    updateVisibleItems();

    // Update visible items when the window is resized
    window.addEventListener("resize", updateVisibleItems);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateVisibleItems);
    };
  }, [items]);

  const handleClick = (value) => {
    const newIndex = slideIndex + value;
    // Check if newIndex is out of bounds and adjust accordingly
    const adjustedIndex =
      newIndex < 0 ? visibleItems.length - 1 : newIndex % visibleItems.length;

    setSlideIndex(adjustedIndex);
  };

  return (
    <Container $baseStyle={cntStyle}>
      <Container $baseStyle={contentCntStyle} $mStyle={gapStyle}>
        <Button $baseStyle={paddingStyle} onClick={() => handleClick(-1)}>
          <Arrow $direction="left" />
        </Button>
        {visibleItems[slideIndex]?.map((item, index) => (
          <Component key={index} item={item} />
        ))}
        <Button $baseStyle={paddingStyle} onClick={() => handleClick(1)}>
          <Arrow $direction="right" />
        </Button>
      </Container>
      <Container>
        {visibleItems?.map((_, index) => (
          <Dot
            key={index}
            $active={index === slideIndex}
            onClick={() => setSlideIndex(index)}
          />
        ))}
      </Container>
    </Container>
  );
};

export default Carousel;
